<template>
  <footer class="footer">
    <div>
      <div class="qrcode">
        <img :src="tenantInfo.qrcode" alt="" />
      </div>
      <h3>xxx官方公众号</h3>
      <p>邮箱地址：service@xxx.cn</p>
      <p>客服电话：400-0596-872</p>
    </div>
    <div class="copyright">
      <span
        >Copyright&nbsp;©&nbsp;{{ year }}&nbsp;{{
          tenantInfo.brandName
        }}&nbsp;ALL RIGHTS RESERVED&nbsp;</span
      >
      <span
        >&nbsp;ICP备案号：<a href="http://beian.miit.gov.cn/">{{
          tenantInfo.footer.beian
        }}</a></span
      >
    </div>
  </footer>
</template>
<script>
import Vue from "vue";
import { TENANT_CONFIG } from "@/store/mutation-types";
export default {
  name: "Footer",
  data() {
    return {
      year: new Date().getFullYear(),
      tenantInfo: {},
    };
  },
  created() {
    this.tenantInfo = Vue.ls.get(TENANT_CONFIG);
  },
};
</script>
<style lang="less" scoped>
footer {
  background: #fafbff;
  width: 100%;
  padding-top: 20px;
  padding-bottom: 15px;
  text-align: center;
  .qrcode {
    width: 150px;
    height: 150px;
    border: solid 1px gray;
    padding: 5px;
    margin: auto;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .copyright,
  .copyright a {
    color: #242425;
    opacity: 0.8;
    font-size: 16px;
  }
}
</style>